"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToScaleYourOperations() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    interface Particle {
      x: number;
      y: number;
      vx: number;
      vy: number;
      size: number;
      opacity: number;
      opacityDir: number;
    }
    const particles: Particle[] = [];
    const particleCount = 30;
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        size: Math.random() * 2 + 1,
        opacity: Math.random() * 0.5 + 0.2,
        opacityDir: Math.random() > 0.5 ? 1 : -1
      });
    }
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "rgba(255, 184, 45, 0.03)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      particles.forEach(particle => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        particle.opacity += particle.opacityDir * 0.002;
        if (particle.opacity <= 0.1 || particle.opacity >= 0.7) {
          particle.opacityDir *= -1;
        }
        if (particle.x < 0) particle.x = canvas.width;
        if (particle.x > canvas.width) particle.x = 0;
        if (particle.y < 0) particle.y = canvas.height;
        if (particle.y > canvas.height) particle.y = 0;
        ctx.fillStyle = `hsla(35, 92%, 54%, ${particle.opacity})`;
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fill();
      });
      requestAnimationFrame(animate);
    };
    animate();
    const handleResize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return <section data-section-id="246027" id="ready-to-claim-your-spot" className="dark bg-background text-foreground relative py-20 px-4 sm:py-32 overflow-hidden">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full opacity-30" aria-hidden="true" />

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-default text-4xl sm:text-5xl font-bold mb-8 tracking-tight">
          Is Your Industry Still
          <span className="block text-primary"> Available?</span>
        </h2>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          <span className="px-3 py-1 rounded-full bg-muted/10 border border-border text-xs font-medium text-muted-foreground">Real Estate - CLAIMED</span>
          <span className="px-3 py-1 rounded-full bg-muted/10 border border-border text-xs font-medium text-muted-foreground">HVAC - CLAIMED</span>
          <span className="px-3 py-1 rounded-full bg-muted/10 border border-border text-xs font-medium text-muted-foreground">Dentistry - CLAIMED</span>
        </div>

        <div className="flex justify-center">
          <Link to="/ContactPage" className="no-underline">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl animate-pulse rounded-md font-default font-bold text-lg px-10 py-6">
              Claim Your Category
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}